import { render, staticRenderFns } from "./SelectedConfiguration.vue?vue&type=template&id=9d872716&scoped=true&"
import script from "./SelectedConfiguration.vue?vue&type=script&lang=js&"
export * from "./SelectedConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d872716",
  null
  
)

export default component.exports